import { ChangeEvent } from "react";
import MpNumberTextField from "src/components/MpTextFieldNumberOnly";
import { useTranslation } from "src/hooks";
import { useBatchApproveAllowanceFormContext } from "../../../contexts";

function ThresholdNumberTextField({
  value,
  onChange,
}: {
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}) {
  const { tc } = useTranslation("common");
  const { translate: t, fields } = useBatchApproveAllowanceFormContext();

  const label = t("threshold");

  return (
    <>
      <div>{label}</div>
      <MpNumberTextField
        value={value}
        label={tc("phInputField", { fieldName: label })}
        onChange={onChange}
        disabled={fields.isPreparedAddresses}
      />
    </>
  );
}

export default ThresholdNumberTextField;
